import React from "react";
export const LoaderSetterContext = React.createContext({
	setIsLoading: (value: boolean) => {},
});

export const LoaderGetterContext = React.createContext({ isLoading: false });
